<div
  class="app__itemCard w-full min-h-fit max-h-[300px] justify-start h-fit"
  [ngClass]="{ 'max-h-full': isFromNetworkRequest }"
  style="box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1)"
>
  <p class="app__form--attribute--title font-semibold text-base m-0">
    {{ relationshipType | relationshipTypePlural }}
    @if (user) {
    <span class="text-k-blue">({{ filteredList.length }})</span>
    }
  </p>
  <div class="overflow-y-auto h-[75%] py-3 my-2 mt-4 pt-0">
    @if (filteredList.length > 0) { @for (user of filteredList; track user) {
    <div
      [class]="
        user
          ? 'flex items-center gap-2 rounded-lg px-2 p-2 border border-[#ddddd3] font-semibold text-center text-[#515765] hover:bg-light-blue cursor-pointer h-16 w-full text-xs sm:text-sm justify-between my-2 '
          : 'flex items-center gap-2 rounded-lg px-2 p-2 border border-[#ddddd3] font-semibold text-center text-[#515765] bg-[#f3f2f2] cursor-pointer h-16 w-full text-xs sm:text-sm justify-between'
      "
      [matTooltip]="user?.user_first_name + ' ' + user?.user_last_name"
      matTooltipPosition="above"
    >
      <div class="flex gap-2 items-center">
        <app-user-avatar size="52" [name]="user" cornerRadius="100"></app-user-avatar>
        <div class="flex items-start flex-col">
          <p class="m-0 flex items-center gap-2">
            {{ user?.user_first_name + ' ' + user?.user_last_name | truncateStrPipe : 28 }}
            @if (user?.connection_status != 'approved') { @if(!user.relationshipRequests){
            <span class="app__request-badge">
              <span class="material-icons material-symbols-fill text-xs mr-2"> check_circle </span>
              {{ user?.connection_status == 'invited' ? ' Invited' : user?.from_user_id == currentUser.id ? ' Request Sent' : '  Request Sent' }}
            </span>
            } }
          </p>
          <span class="text-k-light-grey font-medium text-xs"> {{ user?.relationship_name }} </span>
        </div>
      </div>
      @if (spouseList && !user.relationshipRequests) {
      <div class="flex gap-3 items-center justify-between">
        @if(user.user_id | networkGuardianAccessMe : guardianLIst){
        <button
          mat-button
          class="app__btn--secondary--small border border-k-blue text-k-blue m-0 px-3 py-2 w-fit h-8 items-center font-semibold text-xs"
          (click)="startImpersonating(user)"
        >
          Open Account
        </button>
        } @if ((user?.connection_status === 'approved' && user?.connection_status == 'approved') && (guardianLIst?.length && user.user_id |
        networkGuardianAccessMe : guardianLIst)) {
        <button class="flex items-center justify-center rounded-[50%] p-3 w-[32px] h-[32px] bg-[#EBF0FA]" (click)="editGuardian(user)">
          <span class="material-icons cursor-pointer text-k-blue text-lg material-symbols-outlined"> edit </span></button
        >}@else{
        <button class="flex items-center justify-center rounded-[50%] p-3 w-[32px] h-[32px] bg-[#EBF0FA]" (click)="editAdminDialogFunction(user)">
          <span class="material-icons cursor-pointer text-k-blue text-lg material-symbols-outlined"> edit </span>
        </button>
        }
        @if (isGuardianStatus(user.user_id)) {
        <button class="flex items-center justify-center rounded-[50%] p-3 w-[32px] h-[32px] bg-[#FDf2f2]" (click)="deleteRequest(user)">
          <img src="/assets/images/trash-2.svg" alt="" class="w-4 h-4" />
        </button>
        }
      </div>
      } @else if(user.relationshipRequests){
      <div class="w-[50%] flex justify-end">
        <div class="action__item__request-btn gap-2 flex items-center">
          <button
            class="app__btn--secondary--small border-k-blue text-k-blue m-0 px-[19.5px] py-2 w-[87px] h-8 items-center"
            (click)="declineRelationshIpRequest(user)"
          >
            Delete
          </button>
          <button
            class="app__btn--primary--small m-0 px-[19.5px] py-2 sm:text-sm text-xxs w-[87px] h-8 items-center"
            (click)="acceptRelationshIpRequest(user)"
          >
            Accept
          </button>
        </div>
      </div>
      }
    </div>
    } } @else {
    <div
      [class]="
        'flex items-center gap-2 rounded-lg px-2 p-2 border border-[#ddddd3] font-semibold text-center text-[#515765] bg-[#f3f2f2] cursor-pointer h-16 w-full text-xs sm:text-sm justify-between'
      "
      [ngClass]="{ 'h-[46px]': isFromNetworkRequest }"
      matTooltipPosition="above"
    >
      <p class="text-center flex items-center justify-center m-0 w-full text-[#b1acb0] gap-1">
        <span class="material-icons cursor-pointer text-lg material-symbols-outlined" (click)="editAdminDialogFunction(user.id)"> person </span>
        No {{ !showCheckBox ? 'connections' : relationshipType.toLowerCase() }} to show
      </p>
    </div>
    }
  </div>
  <div class="flex gap-3 items-center justify-between w-full">
    <button class="app__btn--primary p-[10px]" (click)="addNewUser()" [ngClass]="{ 'm-0': isFromNetworkRequest, 'my-2': !isFromNetworkRequest }">
      {{ !showCheckBox ? 'Create New User' : ' Add New User' }}
    </button>
    <button
      class="app__btn--primary p-[10px]"
      (click)="searchExistingUsers()"
      [ngClass]="{ 'm-0': isFromNetworkRequest, 'my-2': !isFromNetworkRequest }"
    >
      {{ !showCheckBox ? 'Global User Search' : 'Global User Search' }}
    </button>
  </div>

  @if(showCheckBox){ @if (filteredList.length < 1) {
  <div class="flex gap-3 items-center">
    <app-shared-checkbox class="connect-form-checkbox" (change)="handleConnectCheck($event.checked)">
      <mat-label class="automtic-form-desing-lable">
        <span style="color: black">
          I don't want to connect to {{ user?.first_name ?? 'name' }}'s {{ relationshipType | relationshipTypePlural }}
        </span>
      </mat-label>
    </app-shared-checkbox>
  </div>
  } }
</div>
